<template>
	<div class="full">
		<vxe-grid v-bind="gridOptions" v-if="gridOptions" :loading="loading" ref="pricefluctuationsLog"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		props: {
			currentRow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {
			currentRow(e) {
				if (e) {
					this.$api.log.list({
						uniquecode:e.goodscode,
						formname:'c_pricefluctuations',
					}).then((res) => {
						//console.log(res)
						this.$refs.pricefluctuationsLog.reloadData(res)
					})
				} else {
					this.tableData = []
				}
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.gridOptions = this.getOption()	
		},
		methods: {
			getOption() {
				return {
					id: 'pricefluctuationsLog',
					border: true,
					size: 'mini',
					columns: this.getColumns(),
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					cellStyle:this.cellStyle,
					toolbarConfig: {
						size: 'mini',
						perfect: false,
						buttons: [],
						customConfig: {
							storage: true
						},
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: 'auto',
					pagerConfig: {
						enable: false
					},
					proxyConfig: {},
					sortConfig: {
						remote: false
					}
				}
			},
			getColumns() {
				return [{
					field: 'staffid',
					title: '操作人',
					formatter:({row})=>{
						return window.systemMethods.getstaff(row.staffid)
					}
				}, {
					field: 'detail',
					title: '调整价格',
					formatter:({row})=>{
						return '调整价格：'+parseFloat(row.param.price).toFixed(2) + ' | 调价仓库：'+row.param.warehouse
					}
				}, {
					field: 'reason',
					title: '调价原因',
					formatter:({row})=>{
						return row.param.reason
					}
				}, {
					field: 'file',
					title: '附件',
					slots:{
						default:({row})=>{
							if(row.param.file){
								return <upload value={row.param.file} readonly />
							}
							return null
						}
					}
				}, {
					field: 'create_time',
					title: '操作时间',
					formatter:({row})=>{
						return window.systemMethods.timestampToDate(row.create_time,false)
					}
				}]
			}
		},
		components: {
			
		}
	}
</script>